import React, { useEffect, useRef, useState } from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./ListRegister.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  getKyLuat,
  searchCauHinhLuong,
  searchEmployeeAPI,
} from "../../../../../redux/reducer/employee";
import { ColumnProps } from "../../../../../types/models";

import {
  Button,
  Col,
  Popover,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from "antd";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
  Search,
} from "../../../../../components/common";
import Icons from "../../../../../assets/icons";
import { ExcelSVG, SaveWhiteIconSVG } from "../../../../../assets";
import { ReactComponent as WordSVG } from "assets/images/svg/word.svg";
import ModalCustom from "../../../../../components/common/ModalCustom/ModalCustom";
import RegisterNew from "./FormRegister/RegisterNew";
import Notification from "../../../../../components/common/notification/notification";
import { employeeService } from "api";
import axiosClient from "../../../../../api/axiosClient";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
  convertIosStringToDateObjectDayjs,
  convertIosDateToString,
  separateDate,
  formatDateToString,
} from "../../../../../helper/common";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { FileWordFilled, FileWordTwoTone } from "@ant-design/icons";
import { setButtonsHeader } from "redux/reducer/common";
import usePermission from "hooks/usePermission";
import "./ListRegister.scss";
import RenderTemplate from "components/common/DocxTemplate/RenderTemplate";
import { FORMAT_TIME } from "types/enums";
import { RangePickerProps } from "antd/es/date-picker";
const ListRegister = () => {
  const { isQuanLy, isGiamDoc, isAdminHCNS } = usePermission();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 1000,
  });
  const [dataNghiPhepDocx, setDataNghiPhepDocx] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState();
  let savedTableOption = getTableOptions(
    "LISTREGISTER_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((e) => e.show == true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector((state) => state.employeesReducer);
  const modalRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const fileDocxRef = useRef<HTMLInputElement>(null);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  const onClickSearch = async () => {
    setCurrentPage(1);
    // var searchFields = expandRef?.current?.getData();
    // setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
    const formValue = expandRef?.current?.getData();
    const searchFields = {
      ...formValue,
      thoiGianTu: formatDateToString(formValue.thoiGianTu,FORMAT_TIME.timeDetail),
      thoiGianDen: formatDateToString(formValue.thoiGianDen,FORMAT_TIME.timeDetail),
    //  end: formatDateToString(formValue.end, FORMAT_TIME.dayFull),
    };
    setParams({...formValue,...params, ...searchFields,page: 1});
  };
  const getList = async () => {
    setLoading(true);
    try {
      const response = await employeeService.getListRegister(params);
      setData(response.data.items);
      setTotal(response.data.total);
      setLoading(false);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi load danh sách nghỉ phép");
      setLoading(false);
    }
  };
  useEffect(() => {
    getList();
  }, [params]);
  useEffect(() => {
    dispatch(
      searchEmployeeAPI({
        page: 1,
        limit: 1000,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsKLFields(employees.employeesList, "idNhanVien");
    onClickSearch();
  }, [employees.employeesList]);
  const setOptionsKLFields = (list, hoTen) => {
    if (inputFieldsInit.find((field) => field.name === hoTen)) {
      inputFieldsInit.find((field) => field.name === hoTen).options = list?.map(
        (item) => ({
          value: item.id,
          label: item.hoTen,
        })
      );
    }
  };
  //   useEffect(() => {
  //     setData(
  //       employees.CauHinhLuongList.map((list) => ({
  //         ...list,
  //         key: list.id,
  //         //  giaTri:list.giaTri.toFixed(5),
  //       }))
  //     );
  //   }, [employees.CauHinhLuongList]);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = expandRef.current.getData()?.thoiGianDen;
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = expandRef.current.getData()?.thoiGianTu;
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find((e) => e.name == "thoiGianTu").disabledDate =
      disabledDateStart;
    inputFieldsInit.find((e) => e.name == "thoiGianDen").disabledDate =
      disabledDateEnd;
    setFieldInfo([...inputFieldsInit]);
  }, []);
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };

  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportExcel(params);
  };

  const handleExportExcel = async (params) => {
    const url = "hanhchinhnhansu/dang-ky-nghi-phep/file-dang-ky-phep";
    const baseName = "mẫu-file-xin-nghi-phep";
    const fileExtension = "docx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Docx");
    }
  };
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "LISTREGISTER_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const deleteRegister = async (id) => {
    try {
      const res = await employeeService.deleteRegister(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
    getList();
  };
  const handlePrint = (id) => {
    setType("In");
    // dispatch(setIdPhieuKham(id));
    modalRef.current.setIdPK(id);
    modalRef?.current.openModal();
  };
  // const hasPermission = (record: any) => {
  //   if (record.trangThaiDuyet === "00" || record.trangThaiDuyet === "01" ||)
  //     return true;

  //   return false;
  // };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      // const datas = data.filter(
      //   (item: any) => item.trangThai === "01" || item.trangThai === "02"
      // );
      const res = await employeeService.updateListRegister(data);
      getList();
      if (res.data === 200) {
        Notification("warning", res.data);
      }
      Notification("success", "Cập nhập thành công ");
      setLoading(false);
    } catch (res) {
      Notification("error", "Cập nhập thất bại");
      setLoading(false);
    }
  };
  allColumns.map((record) => {
    if (record.dataIndex == "trangThai") {
      record.render = (value, record, index) => {
        return (
          <Select
            className="select-app"
            style={{
              width: "100%",
              backgroundColor:
                value === "01" || value === "Chấp thuận"
                  ? "#24a607"
                  : value === "02" || value === "Từ chối"
                  ? "#f00c0c"
                  : value === "00" || value === "Chờ duyệt"
                  ? "#393a38"
                  : "transparent",
              borderRadius: "5px",
              //  color: "#fff"
              //  color: value === "Chấp thuận" ? "#fff" : value === "Từ chối" ? "#fff" : "#000"
            }}
            value={value}
            options={[
              { value: "01", label: "Chấp thuận" },
              { value: "02", label: "Từ chối" },
            ]}
            disabled={!isAdminHCNS()}
            onChange={async (val) => {
              const newData = [...data];
              newData[index]["trangThai"] = val;
              setData(newData);
            }}
          />
        );
      };
    }
  });

  const onDownloadDocx = async (id: string | number) => {
    if (id) {
      try {
        const res = await employeeService.getTemplateDkNghiPhep(id);
        const {
          form_in,
          thong_tin_hop_dong,
          nhan_vien,
          thong_tin_ngay_nghi_phep_duoc_huong,
          thong_tin_thoi_gian_dk_nghi,
        } = res.data.data;
        console.log(res.data.data);
        const date = separateDate(new Date())
        
        setDataNghiPhepDocx({
          ngay_dang_ky_nghi: form_in.ngay_lap,
          bo_phan: thong_tin_hop_dong.bo_phan,
          chuc_vu: thong_tin_hop_dong.chuc_vu,
          ho_ten: nhan_vien.ho_ten,
          ma_nhan_vien: nhan_vien.ma_nhan_vien,
          ngay_nghi_phep_da_su_dung:
            thong_tin_ngay_nghi_phep_duoc_huong.ngay_nghi_phep_da_su_dung || "0",
          ngay_nghi_phep_duoc_huong:
            thong_tin_ngay_nghi_phep_duoc_huong.ngay_nghi_phep_duoc_huong || "0",
          tong_cong_ngay_nghi_phep_con_lai:
            thong_tin_ngay_nghi_phep_duoc_huong.tong_cong_ngay_nghi_phep_con_lai || "0",
          den_het_ngay: thong_tin_thoi_gian_dk_nghi.den_het_ngay,
          ngay_bat_dau_di_lam_lai:
            thong_tin_thoi_gian_dk_nghi.ngay_bat_dau_di_lam_lai,
          ngay_lam_viec_cuoi_cung_truoc_khi_nghi:
            thong_tin_thoi_gian_dk_nghi.ngay_lam_viec_cuoi_cung_truoc_khi_nghi,
          tong_so_ngay_xin_nghi:
            thong_tin_thoi_gian_dk_nghi.tong_so_ngay_xin_nghi,
          tu_ngay: thong_tin_thoi_gian_dk_nghi.tu_ngay,
          ngay: date.day,
          thang: date.month,
          nam: date.year,
        });
      } catch (err: any) {
        Notification("warning", err.message || "Có lỗi khi lấy mẫu in");
      }
    }
  };

  const handleDocxTemplateClick = async (id: string | number) => {
    await onDownloadDocx(id);
    fileDocxRef.current?.fillDocx();
  };

  useEffect(() => {
    const newColumns = columns;
    columns.find((e) => e.dataIndex == "action").render = (
      value,
      _record,
      index
    ) => {
      return (
        <ListActionButton
          editFunction={() => {
            setType("Sửa");
            setRecord(_record);
            modalRef.current?.openModal();
          }}
          printFunction={() => handleDocxTemplateClick(_record.id)}
        ></ListActionButton>
      );
    };
    setColumns(newColumns);
  }, []);

  return (
    <div className="recruitment-list" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="recruitment-container">
        <div className="container">
          <ExpandSearch
            ref={expandRef}
            fields={fieldInfo}
            onClickSearch={onClickSearch}
            // Ẩn nút "Tìm kiếm nâng cao"
            isSearchExpend={false}
            isResetField={false}
          />
        </div>
        <div className="container">
          <Space style={{ width: "100%" }} direction="vertical">
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"400px"}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icons.bars rev={0} />}
                    className="btn-sub"
                    type="ghost"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              <Col>
                <Space style={{ width: "100%" }}>
                  {/* <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<FileWordFilled style={{ color: "#2b5797", fontSize: "18px" }} rev={undefined} />}
                  >
                    <Typography>Xuất mẫu file</Typography>
                  </Button> */}
                  {/* <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUpload}
                    ref={fileInputRef}
                  /> */}
                  {/* <Button
                    icon={<Icons.upload rev={0} />}
                    className="btn-sub"
                    type="ghost"
                    onClick={handleClick}
                    style={{
                      width: "100px",
                    }}
                  >
                    Import
                  </Button> */}
                  <Button
                    className="custom-btn"
                    type="primary"
                    htmlType="submit"
                    onClick={handleSubmit}
                    icon={<SaveWhiteIconSVG />}
                    disabled={!isAdminHCNS()}
                  >
                    Lưu lại
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      setType("Thêm");
                      setRecord(null);
                      modalRef.current?.openModal();
                    }}
                  >
                    Thêm mới
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: total,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    // onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{ x: scrollX }}
              />
            )}
            <ModalCustom
              ref={modalRef}
              width={1000}
              title={`${type} đăng ký nghỉ phép`}
            >
              <RegisterNew
                data={record}
                datas={data}
                getListApi={getList}
                type={type}
                setCurrentPage={null}
              ></RegisterNew>
            </ModalCustom>
            <RenderTemplate
              ref={fileDocxRef}
              data={dataNghiPhepDocx}
              templatePath="/files/MauDonXinNghiPhep.docx"
              outputName="Mẫu đơn xin nghỉ phép.docx"
              label={""}
            >
              <></>
            </RenderTemplate>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListRegister;
